import { type Dispatch } from 'redux';
import { AppAction } from './enums.ts';
import type {
  AuthorizePageAction, ShowOverlayAction,
  UpdateConfigAction,
  UpdateImageQueuePatientStatusAction,
  UpdateMeAction, UpdatePageAction, UpdatePatientAction, UpdatePatientIdAction,
  UpdateSettingsAction, UpdateSystemSettingsAction, VerifyDisabledAction
} from './types';
import type { Route } from '../../routes.ts';
import type { ImageQueuePatientStatus } from '../../types/Image.d.ts';
import type { Patient } from '../../types/Patient.d.ts';
import type { Config, Settings, SystemSettings } from '../../types/Settings.d.ts';
import type { UserInfo } from '../../types/UserInfo.d.ts';
import type { RouteParams, RouteQuery } from '../../utils/router/Router.ts';
import { createAction } from '../createAction.ts';

export const disableVerify = createAction(() =>
  (dispatch: Dispatch<VerifyDisabledAction & { type: string }>) => {
    dispatch({ type: AppAction.VerifyDisabled, disabled: true });
  }
);

export const enableVerify = createAction(() =>
  (dispatch: Dispatch<VerifyDisabledAction & { type: string }>) => {
    dispatch({ type: AppAction.VerifyDisabled, disabled: false });
  }
);

export const showOverlay = createAction(() =>
  (dispatch: Dispatch<ShowOverlayAction & { type: string }>) => {
    dispatch({ type: AppAction.ShowOverlay, show: true });
  }
);

export const hideOverlay = createAction(() =>
  (dispatch: Dispatch<ShowOverlayAction & { type: string }>) => {
    dispatch({ type: AppAction.ShowOverlay, show: false });
  }
);

export const updateConfig = createAction((config: Config) =>
  (dispatch: Dispatch<UpdateConfigAction & { type: string }>) => {
    dispatch({ type: AppAction.UpdateConfig, config });
  }
);

export const updateMe = createAction((me?: UserInfo) =>
  (dispatch: Dispatch<UpdateMeAction & { type: string }>) => {
    dispatch({ type: AppAction.UpdateMe, me });
  }
);

export const updateSettings = createAction((settings?: Settings) =>
  (dispatch: Dispatch<UpdateSettingsAction & { type: string }>) => {
    dispatch({ type: AppAction.UpdateSettings, settings });
  }
);

export const updateImageQueuePatientStatus = createAction((imageQueuePatientStatus?: ImageQueuePatientStatus) =>
  (dispatch: Dispatch<UpdateImageQueuePatientStatusAction & { type: string }>) => {
    dispatch({ type: AppAction.UpdateImageQueuePatientStatus, imageQueuePatientStatus });
  }
);

/** @function */
export const updatePatientId = createAction((patientId: string) =>
  (dispatch: Dispatch<UpdatePatientIdAction & { type: string }>) => {
    dispatch({ type: AppAction.UpdatePatientId, patientId });
  }
);

export const updatePatient = createAction((patient?: Patient) =>
  (dispatch: Dispatch<UpdatePatientAction & { type: string }>) => {
    dispatch({ type: AppAction.UpdatePatient, patient });
  }
);

export const updateSystemSettings = createAction((systemSettings?: SystemSettings) =>
  (dispatch: Dispatch<UpdateSystemSettingsAction & { type: string }>) => {
    dispatch({ type: AppAction.UpdateSystemSettings, systemSettings });
  }
);

export const navigate = createAction((page: Route, loadFile: MaybePromiseFunction | undefined,
  params: RouteParams, query: RouteQuery, requiresAuth: boolean) =>
  async (dispatch: Dispatch<UpdatePageAction & { type: string }>) => {
    dispatch({ type: AppAction.UpdatePage, page, params, query, requiresAuth });
    await loadFile?.();
  }
);

export const authorize = createAction((page: Route, granted: boolean) =>
  (dispatch: Dispatch<AuthorizePageAction & { type: string }>) => {
    dispatch({
      type: AppAction.AuthorizePage,
      page,
      granted
    });
  }
);
